import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { IRessourceCategory } from '../models/ressource-category';
import { RessourceCategoryService } from '../services/ressource-category.service';
import { NameValidators } from 'src/app/shared/validators/name.validators';

@Component({
    selector: 'app-ressource-category',
    templateUrl: './ressource-category.component.html',
    styleUrls: ['./ressource-category.component.css'],
    standalone: false
})
export class RessourceCategoryComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private RessourceCategoryService : RessourceCategoryService
  ) { }

  ressourceCategorys : IRessourceCategory[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;



  ngOnInit(): void {
    this.ressourceCategorys = this.route.snapshot.data.ressourceCategories as IRessourceCategory[];
  }

  updateList(){
    this.RessourceCategoryService.searchRessourceCategories({pageNumber: 0, pageSize: 999999})
    .pipe(first())
    .subscribe(response => {
      this.ressourceCategorys = response.data;
    })
  }

  addHandler({ sender }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, NameValidators(() => this.ressourceCategorys.map(c => c.name), 75, true)),
      color: new UntypedFormControl(null, Validators.required),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }){
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name,
        NameValidators(() => this.ressourceCategorys.filter(c => c.id !== dataItem.id).map(c => c.name), 75, true)),
      color: new UntypedFormControl(dataItem.color, Validators.required),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const id = event.dataItem.id ?? null;
    const request: any = {
      name: event.formGroup.value.name?.trim(),
      color: event.formGroup.value.color,
      id,
    }

    const save$ = id
      ? this.RessourceCategoryService.updateRessourceCategory(request)
      : this.RessourceCategoryService.createRessourceCategory(request);

    // Close the row only on success, so the input survives a rejected save (errors are shown by the interceptor).
    save$.subscribe(() => {
      event.sender.closeRow(event.rowIndex);
      this.updateList();
    });
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.RessourceCategoryService.deleteRessourceCategory(dataItem.id)
    .subscribe(response => {
      this.updateList();
    });;
  }

}
